import GlobalController from '../base-controllers/GlobalController';

import { debounce } from '../utils/js';

/**
 * Controller for calculating the viewport height(100vh) and set a CSS custom
 * property with the calculated value. The value is being updated on window
 * resize.
 *
 * This is especially needed for mobile browsers where 100vh is the maximum
 * window height without any browser UI. Using 100vh to position something at
 * the bottom of the screen could make it unreachable if the browser's address
 * bar is visible.
 *
 * - https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 *
 * TODO: keep an eye on dynamic viewport height (dvh)
 * https://www.bram.us/2021/07/08/the-large-small-and-dynamic-viewports/
 */
export default class ViewportHeight extends GlobalController {
  static id = 'ViewportHeight';

  /**
   * DOM loaded.
   */
  init() {
    this.calculateHeight();

    this.on(window, 'resize', this.handleResize);
  }

  /**
   * Calculate the height on resize.
   */
  handleResize = debounce(() => {
    this.calculateHeight();
  }, 250);

  calculateHeight() {
    document.documentElement.style.setProperty(
      '--vh100',
      `${window.innerHeight}px`,
    );
  }
}
